import { Skeleton } from "antd";
import { useFetchLocalStorage } from "lib/useFetchLocalStorage";
import useUser from "lib/useUser";
import TodoTemplateList from "components/todo/template/list";
import SectionTitle from "components/shared/SectionTitle";
import * as ROUTES from "constants/routes";

function TodoTemplate() {
  useFetchLocalStorage();
  const { status, user } = useUser({ redirectTo: "/login" });

  if (status === "loading" || !user) return <Skeleton active />;

  return (
    <>
      <SectionTitle
        title="Todo Template List"
        buttonTo={ROUTES.TODO_TEMPLATE_ADD}
        buttonTitle="Add Template"
      />
      <TodoTemplateList />
    </>
  );
}

export default TodoTemplate;
